import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

// Angular material
import { MatFormFieldModule } from '@angular/material';
import { MatInputModule } from '@angular/material';
import { MatAutocompleteModule, MatDatepickerModule, MatNativeDateModule, MatSnackBarModule } from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// CKEditor
import { CKEditorModule } from 'ng2-ckeditor';

import { DashboardComponent } from './dashboard/dashboard.component';
import { PagesComponent } from './pages.component';
import { PAGES_ROUTES } from './pages.routes';
import { SharedModule } from '../shared/shared.module';
import { CongresosComponent } from './congresos/congresos.component';
import { ModalCategInscComponent } from '../components/modal-categ-insc/modal-categ-insc.component';
import { ModalActividadComponent } from '../components/modal-actividad/modal-actividad.component';
import { ModalCategTrabajoComponent } from '../components/modal-categ-trabajo/modal-categ-trabajo.component';

// Translation Modules
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CategoriaInscripcionComponent } from './categoria-inscripcion/categoria-inscripcion.component';
import { ActividadesComponent } from './actividades/actividades.component';
import { CategoriaTrabajoComponent } from './categoria-trabajo/categoria-trabajo.component';
import { CongresosEditComponent } from './congresos/congresos-edit.component';
import { CodigosInvitacionComponent } from './codigos-invitacion/codigos-invitacion.component';
import { InscriptosCongresoComponent } from './inscriptos-congreso/inscriptos-congreso.component';
import { DashboardAdminComponent } from './dashboard-admin/dashboard-admin.component';
import { TrabajosComponent } from './trabajos/trabajos.component';
import { CategoriaTrabajoInvitadoComponent } from './categoria-trabajo-invitado/categoria-trabajo-invitado.component';
import { ModalCategTrabajoInvitadoComponent } from '../components/modal-categ-trabajo-invitado/modal-categ-trabajo-invitado.component';
import { TrabajosInvitadosComponent } from './trabajos-invitados/trabajos-invitados.component';
import { UsuariosAdminComponent } from './usuarios-admin/usuarios-admin.component';
import { ModalUsuarioAdminComponent } from '../components/modal-usuario-admin/modal-usuario-admin.component';
import { PerfilComponent } from './perfil/perfil.component';
import { TrabajosInvitadosListaComponent } from './trabajos-invitados-lista/trabajos-invitados-lista.component';
import { CertificadosCursosComponent } from '../certificados/certificados-cursos/certificados-cursos.component';
import { InscriptoActividadesListComponent } from './inscriptos-actividad/inscripto-actividades-list.component';
import { InscriptosActividadComponent } from './inscriptos-actividad/inscriptos-actividad.component';
import { ReporteGananciasComponent } from './reporte-ganancias/reporte-ganancias.component';
import { DescargaTrabajosComponent } from './descarga-trabajos/descarga-trabajos.component';
import { DescargaTrabajosInvitadosComponent } from './descarga-trabajos-invitados/descarga-trabajos-invitados.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { NotificationEditComponent } from './notifications/notification-edit/notification-edit.component';
import { TrabajosListaAdminComponent } from './trabajos-lista-admin/trabajos-lista-admin.component';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}



@NgModule({
  imports: [
    CommonModule,
    PAGES_ROUTES,
    SharedModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    BrowserAnimationsModule,
    MatAutocompleteModule,
    MatSnackBarModule,
    MatDatepickerModule,
    MatNativeDateModule,
    CKEditorModule
  ],
  declarations: [
    DashboardComponent,
    PagesComponent,
    CongresosComponent,
    CategoriaInscripcionComponent,
    ModalCategInscComponent,
    ModalActividadComponent,
    ModalCategTrabajoComponent,
    ModalCategTrabajoInvitadoComponent,
    ModalUsuarioAdminComponent,
    ActividadesComponent,
    CategoriaTrabajoComponent,
    CongresosEditComponent,
    CodigosInvitacionComponent,
    InscriptosCongresoComponent,
    DashboardAdminComponent,
    TrabajosComponent,
    CategoriaTrabajoInvitadoComponent,
    TrabajosInvitadosComponent,
    UsuariosAdminComponent,
    PerfilComponent,
    TrabajosInvitadosListaComponent,
    CertificadosCursosComponent,
    InscriptoActividadesListComponent,
    InscriptosActividadComponent,
    ReporteGananciasComponent,
    DescargaTrabajosComponent,
    DescargaTrabajosInvitadosComponent,
    NotificationsComponent,
    NotificationEditComponent,
    TrabajosListaAdminComponent
  ]
})
export class PagesModule { }



// WEBPACK FOOTER //
// ./src/app/pages/pages.module.ts